<template>
  <section>
    <div v-if="!beforeBind" class="bind">
      <section v-if="isStaff">
        <van-nav-bar
          title="我是员工"
          left-arrow
          @click-left="onBack"
        />
        <div class="toast">请先完善个人资料并绑定微信</div>
        <common-input
          v-model="bindData.name"
          :err-msg="nameErrMsg"
          display="false"
          name="姓名"
          :max="20"
          placeholder="请输入姓名"
          @inputBlured="checkName"
        />
        <van-cell class="van-cell--required van-field hasinput" title="性别">
          <van-radio-group v-model="bindData.gender">
            <van-radio name="MALE">男</van-radio>
            <van-radio name="FEMALE">女</van-radio>
          </van-radio-group>
        </van-cell>
        <common-input
          v-model="bindData.phone"
          :err-msg="phoneErrMsg"
          display="false"
          type="tel"
          name="手机号"
          :max="11"
          placeholder="请输入手机号"
          @inputBlured="checkPhone"
          @inputChanged="checkPhone"
        />
        <div class="van-cell hasinput">
          <span :class="codeFlag?'':'active'" class="get-code" @click="GetCode">{{ btnName }}</span>
          <input
            v-model="bindData.smsCode"
            class="van-field__control code_input"
            placeholder="请输入验证码"
            type="number"
            @blur="checkCode"
            @input="checkCode"
          >
          <div v-show="codeErrMsg" class="errMsg">
            <svg-icon icon-class="err" />
            {{ codeErrMsg }}
          </div>
        </div>
        <div class="van-cell hasinput">
          <span>头像</span>
          <div class="avatar">
            <img
              v-if="!bindData.faceImg"
              src="../../assets/img/avatar.png"
              class="_avatar"
              @click="showPopup"
            >
            <img v-else class="_avatar" :src="baseURL + bindData.faceImg" alt>
            <van-icon name="arrow" @click="showPopup" />
          </div>
          <div v-show="imgErr" class="errMsg">
            <van-icon name="warning" />请上传清晰人像用于人脸通行
          </div>
        </div>
        <van-field v-model="bindData.company" class="hasinput" label="公司名称" placeholder="请输入公司名称" />
        <p v-if="showCompanyName" class="bind_toast">
          *绑定微信即代表您已经同意
          <span>
            <router-link :to="'guide'">《康塔科技隐私保护指引》</router-link>
          </span>
        </p>
        <van-button class="sub_btn" type="info" @click="bindStaff">绑定微信</van-button>
      </section>
      <section v-else>
        <van-nav-bar
          title="我是访客"
          left-arrow
          @click-left="onBack"
        />
        <div class="toast">请先完善个人资料并绑定微信</div>
        <common-input
          v-if="filedList.includes('name')"
          v-model="bindData.name"
          :required="filedMustList.includes('name')"
          :err-msg="nameErrMsg"
          display="false"
          name="姓名"
          :max="20"
          placeholder="请输入姓名"
          @inputBlured="checkName"
        />
        <van-cell v-if="filedList.includes('gender')" :class="filedMustList.includes('gender') ? 'van-cell--required van-field hasinput' : 'van-field hasinput'" title="性别">
          <van-radio-group v-model="bindData.gender">
            <van-radio name="MALE">男</van-radio>
            <van-radio name="FEMALE">女</van-radio>
          </van-radio-group>
        </van-cell>
        <common-input
          v-if="filedList.includes('phone')"
          v-model="bindData.phone"
          :required="filedMustList.includes('phone')"
          :err-msg="phoneErrMsg"
          display="false"
          type="tel"
          name="手机号"
          :max="11"
          placeholder="请输入手机号"
          @inputBlured="checkPhone"
          @inputChanged="checkPhone"
        />
        <div v-if="filedList.includes('phone')" class="van-cell hasinput">
          <span :class="codeFlag?'':'active'" class="get-code" @click="GetCode">{{ btnName }}</span>
          <input
            v-model="bindData.smsCode"
            class="van-field__control code_input"
            placeholder="请输入验证码"
            type="number"
            @blur="checkCode"
            @input="checkCode"
          >
          <div v-show="codeErrMsg" class="errMsg">
            <svg-icon icon-class="err" />
            {{ codeErrMsg }}
          </div>
        </div>
        <van-cell v-if="filedList.includes('idType')" :class="filedMustList.includes('idType') ? 'van-cell--required van-field hasinput' : 'van-field hasinput'" title="证件类型">
          <span @click="showType = true" style="color: #323233">{{ bindData.typeName }}</span>
        </van-cell>
        <common-input
          v-if="filedList.includes('idNumber')"
          v-model="bindData.idNumber"
          :required="filedMustList.includes('idNumber')"
          :err-msg="idNumberErrMsg"
          display="false"
          name="证件号码"
          placeholder="请输入证件号码"
          @inputBlured="checkIdNumber"
          @inputChanged="checkIdNumber"
        />
        <div v-if="filedList.includes('faceImg')" :class="filedMustList.includes('faceImg') ? 'van-cell--required van-cell hasinput' : 'van-cell hasinput'">
          <span>头像</span>
          <div class="avatar">
            <img
              v-if="!bindData.faceImg"
              src="../../assets/img/avatar.png"
              class="_avatar"
              @click="showPopup"
            >
            <img v-else class="_avatar" :src="baseURL + bindData.faceImg" alt>
            <van-icon name="arrow" @click="showPopup" />
          </div>
          <div v-show="imgErr" class="errMsg">
            <van-icon name="warning" />请上传清晰人像用于人脸通行
          </div>
        </div>
        <common-input
          v-if="filedList.includes('company')"
          v-model="bindData.company"
          :required="filedMustList.includes('company')"
          :err-msg="companyErrMsg"
          display="false"
          name="公司名称"
          placeholder="请输入公司名称"
          @inputBlured="checkCompany"
        />
        <p v-if="showCompanyName" class="bind_toast">
          *绑定微信即代表您已经同意
          <span>
            <router-link :to="'guide'">《康塔科技隐私保护指引》</router-link>
          </span>
        </p>
        <van-button class="sub_btn" type="info" @click="bindStaff">绑定微信</van-button>
        <div v-show="showType" class="piker_wrap" @click="showType = false">
          <ul class="piker_content" @click.stop>
            <li
              v-for="(item,index) in cardList"
              :key="index"
              :class="{active:active==index}"
              @click="changeCard(item,index)"
            >{{ item.name }}</li>
          </ul>
          <div class="cancel" @click="showType = false">取消</div>
        </div>
      </section>
      <van-popup v-model="show">
        <div class="upload">
          <h5>拍照示例</h5>
          <div class="right_img">
            <img alt src="../../assets/img/img.png">
          </div>
          <p class="tip_text">温馨提示：为保证审核顺利通过，请保持人脸完整清晰，勿用美颜。</p>
          <div class="wrong_img">
            <div>
              <img alt src="../../assets/img/img1.png">
              <p>照片模糊</p>
            </div>
            <div>
              <img alt src="../../assets/img/img2.png">
              <p>比例过小</p>
            </div>
            <div>
              <img alt src="../../assets/img/img3.png">
              <p>人脸不完整</p>
            </div>
            <div>
              <img alt src="../../assets/img/img4.png">
              <p>侧脸拍照</p>
            </div>
          </div>
          <van-uploader :before-read="beforeRead">
            <van-button type="info" style="display: flex; justify-content: center">
              <svg-icon icon-class="album" />
              <span>
                从相册选择
              </span>
            </van-button>
          </van-uploader>
          <van-uploader capture="camera" :before-read="beforeRead">
            <van-button type="default" style="display: flex; justify-content: center">
              <svg-icon icon-class="picture" />拍照
            </van-button>
          </van-uploader>
        </div>
      </van-popup>
      <van-dialog v-model="visible" :before-close="beforeClose" title="请输入计算结果" show-cancel-button>
        <div style="display: flex; padding: 15px 20px">
          <img :src="captchaInfo.captcha" alt="" @click="getImg">
          <van-icon name="replay" color="#3b86ff" @click="getImg" />
          <input
            v-model="bindData.captchaResult"
            class="van-field__control code_input"
            placeholder="请输入计算结果"
          >
        </div>
      </van-dialog>
    </div>
    <div v-if="beforeBind" class="before-bind">
      <div class="before-bind-img">
        <img :src="beforeBindImg" alt="">
      </div>
      <div>
        <van-button
          class="sub_btn"
          type="info"
          @click="goStaff"
        >我是员工</van-button>
        <van-button
          class="sub_btn"
          type="info"
          @click="goVisitor"
        >我是访客</van-button>
      </div>
    </div>
  </section>
</template>

<script>
import commonInput from '@/components/commonInput';
import lrz from 'lrz';
import { bindByStaff, fieldsByVisitor, getCode, onBind } from '@/api/home';
import config from '@/common/config';
import fileUtils from '@/utils/fileUtils';
import { GetUserInfo, Upload, getCaptcha } from '@/api/user';
import { Toast } from 'vant';
import beforeBind from '@/assets/img/beforeBind.png';
// import
export default {
  name: 'Bind',
  components: {
    commonInput
  },
  data() {
    return {
      active: 0,
      beforeBindImg: beforeBind,
      isStaff: true,
      beforeBind: true,
      filedList: [],
      filedMustList: [],
      cardList: [
        { val: 'ID_CARD', name: '身份证'},
        { val: 'PASSPORT', name: '护照'},
        { val: 'HK_PASS', name: '港澳通行证'},
        { val: 'DRIVER_LICENSE', name: '驾照'},
        { val: 'TAIWAN_PASS', name: '台湾通行证'},
        { val: 'OTHER', name: '其他'}
      ],
      bindData: {
        name: '',
        faceImg: '',
        idNumber: '',
        gender: 'MALE',
        idType: 'ID_CARD',
        typeName: '身份证',
        phone: '',
        smsCode: '',
        company: '',
        captchaResult: null
      },
      showCompanyName: this.showCompanyName,
      captchaInfo: {
        open: false
      },
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      btnName: '获取验证码',
      btnDefault: '重发验证码',
      countDown: 60,
      codeInterval: null,
      nameErrMsg: '', // 姓名输入提示
      idNumberErrMsg: '', // 姓名输入提示
      phoneErrMsg: '', // 手机号校验提示
      imgErr: false, // 人脸识别失败提示
      codeErrMsg: '', // 验证码校验失败提示
      showCompanyErr: false,
      companyErrMsg: '',
      show: false,
      showType: false,
      disFlag: true,
      codeFlag: true,
      visible: false,
      imageFileName: '',
      option: {
        img: '',
        outputSize: 0.8,
        info: false, // 裁剪框的大小信息
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: window.innerWidth + 'px', // 默认生成截图框宽度
        autoCropHeight: window.innerWidth + 'px', // 默认生成截图框高度
        high: true, // 是否按照设备的dpr 输出等比例图片
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        mode: '100% auto' // 图片默认渲染方式
      }
    };
  },
  computed: {
    // dataRange() {
    //   let needVal = '';
    //   let needless = '';
    //   needVal = Number(Boolean(this.bindData.name)) + Number(Boolean(this.bindData.phone) + Number(Boolean(this.bindData.smsCode)));
    //   needless = Number(Boolean(this.nameErrMsg)) + Number(Boolean(this.phoneErrMsg) + Number(Boolean(this.codeErrMsg)));
    //   return {
    //     needVal,
    //     needless
    //   };
    // }
  },
  watch: {
    // dataRange(val) {
    //   if (Number(val.needVal) === 3 && Number(val.needless) === 0) {
    //     this.disFlag = false;
    //   } else {
    //     this.disFlag = true;
    //   }
    // },
    $route(to, from) {
      if (from.name === 'user') {
        location.reload();
      }
    }
  },
  created() {
    this.getImg();
    const filedList = [];
    const filedMustList = [];
    fieldsByVisitor({}).then(res => {
      res.data.forEach(item => {
        filedList.push(item.fieldName);
        if (item.must) {
          filedMustList.push(item.fieldName);
        }
      });
      this.filedList = filedList;
      this.filedMustList = filedMustList;
    });
  },
  methods: {
    bindStaff() {
      if (this.checkName() && this.checkPhone() && this.checkCode() && this.checkIdNumber() && this.checkImg() && this.checkCompany()) {
        if (this.isStaff) {
          bindByStaff(this.bindData).then(res => {
            this.$toast.success({
              icon: 'checked',
              message: '绑定成功',
              mask: true,
              className: 'newToast'
            });
            this.disFlag = false;
            const enterUrl = sessionStorage.getItem('enterUrl');
            if (enterUrl === null) {
              const data = {};
              GetUserInfo(data).then(response => {
                if (response.data) {
                  this.personalInfo = response.data;
                  localStorage.setItem('personalInfo', JSON.stringify(this.personalInfo));
                  this.$router.push({ path: '/home' });
                }
              });
            } else {
              if (enterUrl.indexOf('bind') !== -1) {
                const data = {};
                GetUserInfo(data).then(response => {
                  if (response.data) {
                    this.personalInfo = response.data;
                    localStorage.setItem('personalInfo', JSON.stringify(this.personalInfo));
                    this.$router.push({ path: '/home' });
                  }
                });
              } else {
                const data = {};
                GetUserInfo(data).then(response => {
                  if (response.data) {
                    this.personalInfo = response.data;
                    localStorage.setItem('personalInfo', JSON.stringify(this.personalInfo));
                    window.location.href = enterUrl;
                  }
                });
              }
            }
          }).catch(err => {
            console.log(err);
            this.disFlag = false;
          });
        } else {
          onBind(this.bindData).then(res => {
            this.$toast.success({
              icon: 'checked',
              message: '绑定成功',
              mask: true,
              className: 'newToast'
            });
            this.disFlag = false;
            const enterUrl = sessionStorage.getItem('enterUrl');
            if (enterUrl === null) {
              const data = {};
              GetUserInfo(data).then(response => {
                if (response.data) {
                  this.personalInfo = response.data;
                  localStorage.setItem('personalInfo', JSON.stringify(this.personalInfo));
                  this.$router.push({ path: '/home' });
                }
              });
            } else {
              if (enterUrl.indexOf('bind') !== -1) {
                const data = {};
                GetUserInfo(data).then(response => {
                  if (response.data) {
                    this.personalInfo = response.data;
                    localStorage.setItem('personalInfo', JSON.stringify(this.personalInfo));
                    this.$router.push({ path: '/home' });
                  }
                });
              } else {
                const data = {};
                GetUserInfo(data).then(response => {
                  if (response.data) {
                    this.personalInfo = response.data;
                    localStorage.setItem('personalInfo', JSON.stringify(this.personalInfo));
                    window.location.href = enterUrl;
                  }
                });
              }
            }
          }).catch(err => {
            console.log(err);
            this.disFlag = false;
          });
        }
      }
    },
    getImg() {
      getCaptcha({}).then(res => {
        this.captchaInfo = res.data;
        this.bindData.uuid = res.data.uuid;
      });
    },
    beforeRead(file) {
      const that = this;
      this.clip(event, {
        resultObj: file,
        aspectRatio: 1,
        callback: function(data) {
          const formData = new FormData();
          formData.append('file', data);
          formData.append('angle', 0);
          // formData私有类对象，访问不到，可以通过get判断值是否传进去
          Upload(formData).then(res => {
            that.$toast.clear();
            that.bindData.faceImg = res.data;
          }).catch(err => {
            setTimeout(() => { that.$toast.clear(); }, 3000);
          });
        }
      }
      );
      this.show = false;
    },
    afterRead(file) {
      fileUtils.getOrientation(file.file).then((orient) => {
        lrz(file.file, { width: 1024 }).then(rst => {
          const fromData = new FormData();
          // 此时可以自行将文件上传至服务器
          let angle = '0';
          switch (orient) { // Orientation 拍摄方向,旋转角度
            case 6: // 顺时针90°
              angle = '90';
              break;
            case 3: // 逆时针90°
              angle = '180';
              break;
            case 8: // 180°
              angle = '270';
              break;
          }
          fromData.append('file', rst.origin);
          fromData.append('angle', angle);
          // this.$toast.loading({
          //   message: '上传中...',
          //   forbidClick: true,
          //   loadingType: 'spinner',
          //   duration: 0
          // });
          Upload(fromData).then(res => {
            this.$toast.clear();
            this.bindData.faceImg = res.data;
          }).catch(err => {
            console.log(err);
            setTimeout(() => { this.$toast.clear(); }, 3000);
          });
          this.show = false;
        });
      });
    },
    showPopup() {
      this.show = true;
    },
    // 校验手机号
    checkPhone() {
      if (this.isStaff) {
        let phone;
        if (this.bindData.phone == '') {
          phone = false;
          this.phoneErrMsg = '请输入手机号';
        } else if (!(/^1[3456789]\d{9}$/.test(this.bindData.phone))) {
          this.phoneErrMsg = '手机号格式错误，请检查';
          phone = false;
        } else {
          this.phoneErrMsg = '';
          phone = true;
        }
        return phone;
      } else {
        if (this.filedMustList.includes('phone')) {
          let phone;
          if (this.bindData.phone == '') {
            phone = false;
            this.phoneErrMsg = '请输入手机号';
          } else if (!(/^1[3456789]\d{9}$/.test(this.bindData.phone))) {
            this.phoneErrMsg = '手机号格式错误，请检查';
            phone = false;
          } else {
            this.phoneErrMsg = '';
            phone = true;
          }
          return phone;
        } else {
          return true;
        }
      }
    },
    checkCode() {
      if (this.filedMustList.includes('phone')) {
        let code;
        if (this.bindData.smsCode.length > 6) this.bindData.smsCode = this.bindData.smsCode.slice(0, 6);
        if (this.bindData.smsCode.length !== 6) {
          code = false;
          this.codeErrMsg = '请输入六位数验证码';
        } else {
          this.codeErrMsg = '';
          code = true;
        }
        return code;
      } else {
        return true
      }
    },
    checkName() {
      if (this.isStaff) {
        let name;
        if (this.bindData.name == '') {
          name = false;
          this.nameErrMsg = '请输入姓名';
        } else {
          this.nameErrMsg = '';
          name = true;
        }
        return name;
      } else {
        if (this.filedMustList.includes('name')) {
          let name;
          if (this.bindData.name == '') {
            name = false;
            this.nameErrMsg = '请输入姓名';
          } else {
            this.nameErrMsg = '';
            name = true;
          }
          return name;
        } else {
          return true;
        }
      }
    },
    checkIdNumber() {
      if (!this.isStaff) {
        if (this.filedMustList.includes('idNumber')) {
          let idNumber;
          if (this.bindData.idNumber == '') {
            idNumber = false;
            this.idNumberErrMsg = '请输入证件号码';
          } else {
            this.idNumberErrMsg = '';
            idNumber = true;
          }
          return idNumber;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkImg() {
      if (!this.isStaff) {
        if (this.filedMustList.includes('faceImg')) {
          let faceImg;
          if (this.bindData.faceImg == '') {
            faceImg = false;
            this.imgErr = true;
          } else {
            this.imgErr = false;
            faceImg = true;
          }
          return faceImg;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkCompany() {
      if (!this.isStaff) {
        if (this.filedMustList.includes('company')) {
          let company;
          if (this.bindData.company == '') {
            company = false;
            this.companyErrMsg = '请输入公司名称';
          } else {
            this.companyErrMsg = '';
            company = true;
          }
          return company;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    GetCode() {
      // 函数节流
      if (!this.checkPhone()) {
        return;
      }
      if (!this.bindData.captchaResult && this.captchaInfo.open) {
        this.getImg();
        this.visible = true;
        return;
      }
      if (!this.codeFlag) return;
      this.codeFlag = false;
      // 修改按钮名称
      this.btnName = '发送中...';
      const data = { phone: this.bindData.phone };
      if (this.captchaInfo.open) {
        data.captchaUuid = this.bindData.uuid;
        data.captchaResult = this.bindData.captchaResult;
      }
      getCode(data).then(res => {
        if (res.code === 200) {
          // 发送成功
          let _time = this.countDown;
          this.codeInterval = setInterval(() => {
            _time -= 1;
            this.btnName = _time.toString() + '秒后重新获取';
            if (_time <= 0) {
              clearInterval(this.codeInterval);
              // 修改按钮名称
              this.btnName = this.btnDefault;
              this.bindData.captchaResult = '';
              // 恢复函数节流
              this.codeFlag = true;
            }
          }, 1000);
        }
      }).catch(err => {
        console.log(err);
        this.bindData.captchaResult = null;
        this.btnName = '获取验证码';
        this.codeFlag = true;
      });
    },
    beforeClose(action, done) {
      const that = this;
      if (action === 'confirm') {
        if (!this.bindData.captchaResult) {
          Toast.fail({
            icon: 'warning',
            message: '请输入',
            mask: true,
            className: 'newToast'
          });
          return;
        }
        done();
        that.GetCode();
      } else if (action === 'cancel') {
        done(); // 关闭
        that.bindData.captchaResult = null;
      }
    },
    goStaff() {
      this.isStaff = true;
      this.beforeBind = false;
    },
    goVisitor() {
      this.isStaff = false;
      this.beforeBind = false;
    },
    onBack() {
      this.beforeBind = true;
      this.bindData = {
        name: '',
        faceImg: '',
        idNumber: '',
        gender: 'MALE',
        idType: 'ID_CARD',
        typeName: '身份证',
        phone: '',
        smsCode: '',
        company: '',
        captchaResult: null
      };
      this.btnName = '获取验证码';
      this.btnDefault = '重发验证码';
      this.countDown = 60;
      this.codeInterval = null;
      this.nameErrMsg = ''; // 姓名输入提示
      this.phoneErrMsg = ''; // 手机号校验提示
      this.imgErr = false; // 人脸识别失败提示
      this.codeErrMsg = ''; // 验证码校验失败提示
      this.showCompanyErr = false;
      this.companyErrMsg = '';
    },
    changeCard(item, i) {
      this.active = i;
      this.bindData.typeName = item.name;
      this.bindData.idType = item.val;
      this.showType = false;
    },
  }

};
</script>

<style lang="less" scoped>
@import './styles/bind.less';

.height100 {
  height: 100vh;
}
.flex-column-center{
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.col-white {
  background-color: #000000;
  font-size: 18px;
  height: 80px;
  color: #FFFFFF;
  text-align: center;
}

.before-bind {
  height: 100vh;
  background-color: #FFFFFF;
  .before-bind-img {
    width: 100%;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 90%;
    }
  }
}

.piker_wrap {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  .piker_content {
    width: 100%;
    position: absolute;
    bottom: 0.53rem;
    background: #fff;

    li {
      font-size: 0.18rem;
      height: 0.425rem;
      line-height: 0.425rem;
      text-align: center;
      position: relative;

      &.active {
        color: #3b86ff;
      }

      &::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 0;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }

    &:nth-last-child {
      border: none;
    }
  }

  .cancel {
    width: 100%;
    position: absolute;
    bottom: 0;
    background: #fff;
    height: 0.5rem;
    line-height: 0.5rem;
    text-align: center;
    color: #333;
    font-size: 0.18rem;
  }
}

</style>
